<template>
  <div>
    <div id="container" :style="'width:100%;height:'+hight+'px;'"></div>
  </div>
</template>

<script>
export default {
  name: "TMap",
  props:['hight'],
  model: {  // 定义model
    // 父组件v-model绑定的值传递给props中的fatherValue
    prop: 'fatherValue',
    // 通过emit触发childValueChange将内部值传递给父组件v-model绑定的值
    event: 'childValueChange'
  },
  data() {
    return {

      // map show dialog
      isLoadMap: false,
      // map
      map: null,
      // 纬度
      lat: 34.687650, // 经纬度可以先写死
      // 经度
      lng: 113.676959,
      markerLayer: null,
      ls:[]

    }
  },
  mounted() {
    if (!this.isLoadMap) {
      setTimeout(() => {
        this.initMap();
        this.isLoadMap=true;
      }, 300);
    }
  },
  methods: {
    initMap() {
      //定义地图中心点坐标
      var center = new TMap.LatLng(34.687650, 113.676959)
      //定义map变量，调用 TMap.Map() 构造函数创建地图
      this.map = new TMap.Map(document.getElementById('container'), {
        center: center,//设置地图中心点坐标
        zoom: 17.2,   //设置地图缩放级别
        pitch: 43.5,  //设置俯仰角
        viewMode: '2D'
      });
      //创建并初始化MultiMarker
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,  //指定地图容器
        //样式定义
        styles: {
          //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          "myStyle": new TMap.MarkerStyle({
            "width": 25,  // 点标记样式宽度（像素）
            "height": 35, // 点标记样式高度（像素）
            // "src": require("../../../assets/img/title.jpg"),  //图片路径
            // "src": 'https://www.baidu.com/img/flexible/logo/pc/result.png',  //图片路径
            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            "anchor": {x: 16, y: 32}
          })
        },
        //点标记数据数组
        geometries: [{
          "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          "styleId": 'myStyle',  //指定样式id
          "position": new TMap.LatLng(34.687650, 113.676959),  //点标记坐标位置
          "properties": {//自定义属性
            "title": "marker1"
          }
        },
        ]
      });
      this.mapClick(); // 地图点击时获取经纬
    },
    mapClick() {
      // 通过$emit触发childValueChange（model内定义）事件，将内部值传递给给父组件
      // 获取地图被点击时的经纬度
      this.map.on("click", e => {


        // 点击时获取经纬度
        this.lat = e.latLng.lat;
        this.lng = e.latLng.lng;
        let coordinate={lat:this.lat,lng:this.lng};
        // let c={lat:this.lat,lng:this.lng, count: Math.round(Math.random()*500+100)};
        // this.ls.push(c)
        // console.log(this.ls);
        this.$emit('childValueChange', coordinate)
        this.markerLayer.updateGeometries([
          {
            "styleId": "myStyle",
            "id": "1",
            "position": new TMap.LatLng(this.lat, this.lng),
          }
        ])
      });
    }
  }
}
</script>

<style scoped>

</style>
